import { useEffect, useState } from "react";
import {
  getPerFileProgress,
  subscribePerFileProgress,
} from "@/Service/ChunkedUploadService";
import { isChunkedUploaderActive } from "@/Service/UploaderToggle";

export const useChunkedUploadFiles = (uploadId) => {
  const [files, setFiles] = useState(() => (uploadId ? getPerFileProgress(uploadId) : []));

  useEffect(() => {
    if (!uploadId || !isChunkedUploaderActive()) {
      setFiles([]);
      return undefined;
    }
    setFiles(getPerFileProgress(uploadId));
    const unsubscribe = subscribePerFileProgress(uploadId, (snapshot) => {
      setFiles(snapshot || []);
    });
    return unsubscribe;
  }, [uploadId]);

  return files;
};
